export const color = {
  BLUE: "blue",
  INDIGO: "indigo",
  RED: "red",
  GREEN: "green",
  PINK: "pink",
  VIOLET: "violet",
  LIGHTGREEN: "lightgreen",
};
